export class ApiResponse {
    constructor(status, message) {
        this.status = status;
        this.message = message;
    }
}
